import { msg } from "@lingui/core/macro";
import { Menu } from "@fleet/icons";

import { Button } from "@/components/ui/button";
import { GlobalSearch } from "@/features/search/components/global-search";
import { RestaurantSwitcher } from "@/features/pos/components/restaurant-switcher";
import { AppearanceMenu } from "@/components/appearance-menu";
import { useI18n } from "@/providers/i18n-provider";

interface AppHeaderProps {
  onMenuClick: () => void;
  isNavigating: () => boolean;
}

export function AppHeader(props: AppHeaderProps) {
  const { t } = useI18n();

  return (
    <header class="relative flex h-16 items-center justify-between border-b border-border/20 bg-card/5 px-4 backdrop-blur-sm md:px-6">
      {/* Subtle Loading Bar — GPU-only: animate transform (scaleX) + opacity,
          never `width`/`box-shadow`, to keep this off the layout/paint path. */}
      <div
        class="absolute bottom-[-1px] left-0 z-50 h-[2px] w-full origin-left bg-accent shadow-[0_0_8px_var(--accent)] transition-[transform,opacity] duration-500 ease-out will-change-[transform,opacity]"
        style={{
          transform: props.isNavigating() ? "scaleX(0.7)" : "scaleX(0)",
          opacity: props.isNavigating() ? "1" : "0",
        }}
      />
      <div class="flex items-center gap-4 flex-1">
        <Button
          variant="ghost"
          size="icon"
          class="h-9 w-9 lg:hidden text-muted-foreground hover:text-foreground"
          aria-label={t(msg`Open menu`)}
          onClick={props.onMenuClick}
        >
          <Menu class="h-5 w-5" />
        </Button>
        <GlobalSearch />
        <RestaurantSwitcher />
      </div>
      <div class="flex items-center gap-1">
        {/* Single appearance control: color mode, blur, and gallery.
            Antes eran tres botones para la misma familia de ajustes; los dos
            huecos que quedan son para utilidades de otro tipo. */}
        <AppearanceMenu />
      </div>
    </header>
  );
}
